import React from 'react';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/clients/clients';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { recordDisplay, display, getOptionLabel } from 'src/utils/Utils';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { useTranslation } from 'react-i18next';
import DefaultValue from './DefaultValue';
import { Section } from 'jbc-front/components/Form';
import BranchImageSectionShow from '../containers/BranchImageSectionShow';
import tableStyles from 'src/features/Employees/styles/GeneralTableInfo.scss';
import styles from './BranchInfoSectionShow.scss';

const BranchItem = ({ branchItem, index, regions }) => {
  const { t, i18n } = useTranslation();
  const regionalTaxOfficeName = branchItem.regionalTaxOfficeInformation?.name || '-';
  const managementTaxOfficeName = branchItem.taxOfficeInfo?.name || '-';
  const ssoOfficeName = branchItem.ssoOfficeInfo
    ? i18n.language === 'vi'
      ? branchItem.ssoOfficeInfo.ssoOfficeName
      : branchItem.ssoOfficeInfo.ssoOfficeNameEn
    : '-';
  return (
    <div className={styles.sectionWrap}>
      <Section title={`${t('features.Clients.components.BranchInfoSectionShow.branch_information')} ${index + 1}`}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Clients.components.BranchInfoSectionShow.branch_name')}:</th>
              <td>{branchItem.name}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BranchInfoSectionShow.branch_name_english')}:</th>
              <td>{branchItem.nameEng}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BranchInfoSectionShow.tax_identification_number')}:</th>
              <td>{branchItem.corporateNumber}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BranchInfoSectionShow.social_security_number')}:</th>
              <td>{recordDisplay(branchItem.employerNumber)}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BranchInfoSectionShow.branch_accounting_type')}:</th>
              <td>
                {branchItem.isDependentBranch
                  ? t('features.Clients.components.BranchInfoSectionShow.dependent_accounting')
                  : t('features.Clients.components.BranchInfoSectionShow.independent_accounting')}
              </td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BasicInfoSectionShow.Address')}</th>
              <td>{branchItem.fullAddress}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BasicInfoSectionShow.Phone_number')}</th>
              <td>{branchItem.telNumber}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BasicInfoSectionShow.regional_tax_office')} :</th>
              <td>{regionalTaxOfficeName}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BasicInfoSectionShow.management_tax_office')} :</th>
              <td>{managementTaxOfficeName}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BasicInfoSectionShow.thai_sso_office')} :</th>
              <td>{ssoOfficeName}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BasicInfoSectionShow.region')}</th>
              <td>{display(getOptionLabel(branchItem.region)(regions))}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BranchInfoSectionShow.branch_image')}:</th>
              <td />
            </tr>
          </tbody>
        </table>
        <BranchImageSectionShow index={index} />
      </Section>
    </div>
  );
};

const BranchInfoSectionShow = ({ branch, regions }) => {
  if (branch && branch.length > 0) {
    return <div>{branch.map((item, index) => <BranchItem branchItem={item} key={item.id} index={index} regions={regions} />)}</div>;
  }

  return <DefaultValue />;
};

const mapStateToProps = state => ({
  branch: selector(getItem(REDUCER_NAME, state), 'clientBranch') || {},
  regions: getSelectOptions(state, 'regions')
});

export default connect(mapStateToProps)(BranchInfoSectionShow);
